import { ModuleType } from "../../queryKeyFactory";

export const settingsKeyFactory = {
    readingFormatList : (search): [ModuleType, 'format-list', string] => ['mx', 'format-list', search],
    userUtilityServices: (): [ModuleType, "utility-services"] =>
  ["mx", "utility-services"],
    viewMeterReadingFormatDetail: (id: string): [ModuleType, "meter-reading-format-detail", string] =>
  ["mx", "meter-reading-format-detail", id],
  viewMeterReaders: (page: number, search?): [ModuleType, "meter-reader", number, string] => [
  "mx",
  "meter-reader",
  page,
  search
],
meterReadingStatusList: ( page, search): [ModuleType, "meter-reading-status", number, string] =>
  ["mx", "meter-reading-status", page, search],
meterReasonCodesList: (page, search?,codeId?): [ModuleType, "reason-code-list", number, string,string] => ['mx', "reason-code-list", page, search,codeId],
viewActiveMeterStatuses: (): [ModuleType, "active-reading-status"] =>
  ["mx", "active-reading-status"],
meterReaderDetail: (id: string): [ModuleType, "meter-reader-detail", string] => ["mx", "meter-reader-detail", id],
meterReaderAssignedRoutes: (id: string): [ModuleType, "meter-reader-assigned-routes", string] => ["mx", "meter-reader-assigned-routes", id],
meterReaderReadings: (id: string): [ModuleType, "meter-reader-readings", string] => ["mx", "meter-reader-readings", id],
readFormatFields: (remoteUtilityId: string): [ModuleType, "read-format-fields", string] => ["mx", "read-format-fields", remoteUtilityId],
}